import * as Yup from 'yup';

const CreateAgentValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Please enter a valid email address')
    .required('Please enter an email address'),
  password: Yup.string()
    .min(6, 'Password should be at least 6 characters')
    .required('Please enter a valid password'),
  first_name: Yup.string().required('Please enter a valid first name'),
  last_name: Yup.string().required('Please enter a valid last name'),
});

export default CreateAgentValidationSchema;
